import React from 'react'

import StaffsBox from './StaffsBox'

import { StaffTypeWrapper } from './styles'

export const ManagementStaffs = () => {
  return (
    <StaffTypeWrapper>
      <StaffsBox type={'leader'} />
      <StaffsBox type={'director'} />
      <StaffsBox type={'comanager'} />
    </StaffTypeWrapper>
  )
}
